<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn depressed color="secondary" small v-on="on">{{$t("newBuildingComponent")}}</v-btn>
    </template>
    <v-card>
      <v-tabs fixed-tabs>
        <v-tab ripple>{{$t("newBuildingComponent")}}</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  outlined
                  dense
                  :rules="rules($t('name'))"
                  counter="512"
                  required
                  v-model="name"
                  :placeholder="$t('blockA')"
                  v-bind:label="$t('name')"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  required
                  v-model="description"
                  v-bind:label="$t('description')"
                ></v-text-field>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{$t("close")}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t("save")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";
import axios from "axios";
export default {
  name: "addBuildingComponent",
  data: () => ({
    valid: false,
    dialog: false,
    name: "",
    description: ""
  }),
  methods: {
    close() {
      this.dialog = false;
    },
     rules(property = this.$t('name')) {
      let rules = [
        v => !!v || `${property} ${this.$t("required")}`,
        v => (v && v.length <= 512) || ""
      ];
      return rules;
    },
    save() {
      if (this.$refs.form.validate()) {
        const newBuildingComponent = {
          id: uuid.v4(),
          name: this.name,
          description: this.description,
          createdBy: localStorage.getItem("user"),
          modifiedBy: localStorage.getItem("user"),
          projectId: this.$route.params.id
        };
        this.$emit("add-buildingComponent", newBuildingComponent);
        this.close();
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/BuildingComponents/AddBuildingComponent.vue